import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { APPROVAL_DETAILS_DECISION_STEPS } from '../../constants';

interface Props {
  activeStep: number;
  lastStepLabel?: string;
}

export const DecisionSteps = ({ activeStep, lastStepLabel }: Props) => (
  <Stack direction="row" alignItems="center" gap={2} flexWrap="wrap">
    {APPROVAL_DETAILS_DECISION_STEPS.map((step, index) => (
      <React.Fragment key={step.label}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box
            sx={{
              width: 32,
              height: 32,
              borderRadius: '50%',
              backgroundColor: index <= activeStep ? '#2196F3' : 'action.disabledBackground',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            <step.Icon sx={{ fontSize: 18, color: 'white' }} />
          </Box>
          <Typography
            variant="subtitle2"
            color={index <= activeStep ? 'text.primary' : 'text.secondary'}
            textAlign="center"
            component="span"
          >
            {index === APPROVAL_DETAILS_DECISION_STEPS.length - 1 && lastStepLabel ? lastStepLabel : step.label}
          </Typography>
        </Box>
        {index < APPROVAL_DETAILS_DECISION_STEPS.length - 1 && (
          <Box
            sx={{
              width: 24,
              height: '2px',
              backgroundColor: index < activeStep ? 'primary.main' : 'divider',
              borderRadius: '30px',
            }}
          />
        )}
      </React.Fragment>
    ))}
  </Stack>
);
